var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("" + _vm.type)},[(_vm.message)?_c('span',[_vm._v(_vm._s(_vm.message))]):_vm._e(),_c('i',{staticClass:"fas fa-times",on:{"click":function($event){return _vm.$emit('close')}}})])}
var staticRenderFns = []

export { render, staticRenderFns }